import React from 'react';

export const Logout = ({
  className,
  color,
  height,
  width,
}: {
  className?: string;
  color?: string;
  height?: string;
  width?: string;
}) => (
  <svg
    width={width || '16'}
    height={height || '16'}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.16667 15.5C1.70833 15.5 1.31583 15.3369 0.989167 15.0108C0.663055 14.6842 0.5 14.2917 0.5 13.8333L0.5 2.16667C0.5 1.70833 0.663055 1.31583 0.989167 0.989167C1.31583 0.663055 1.70833 0.5 2.16667 0.5L8 0.5V2.16667L2.16667 2.16667L2.16667 13.8333L8 13.8333L8 15.5L2.16667 15.5ZM11.3333 12.1667L10.1875 10.9583L12.3125 8.83333L5.5 8.83333L5.5 7.16667L12.3125 7.16667L10.1875 5.04167L11.3333 3.83333L15.5 8L11.3333 12.1667Z"
      fill={color || '#6E6B8C'}
    />
  </svg>
);
